const localTomcatConfig = {
  statusBar: {
    visibility: true,
    messgae: "UnderDevelopmentStatusBand",
    color: "red"
  },
  backend: {
    url: "https://localhost:8080/"
  },
  apps: {
    url: "https://localhost:9000/"
  },
  corp: {
    url: "http://localhost:3000/"
  },
  annualReport: {
    url: "https://localhost:9000/annualreport"
  },
  annualReportWithHash: {
    url: "https://localhost:9000/#/annualreport"
  },
  SRU: {
    url: "https://localhost:9000/income-declaration-2"
  },
  NE: {
    url: "https://localhost:9000/income-declaration-1"
  },
  forAccountingCompanies: {
    url: "https://localhost:9000/for-accounting-companies"
  },
  microsoftBusinessCentral: {
    url: "https://localhost:9000/microsoft-business-central-development"
  },
  ContactUs: {
    uploadFileSizeLimit: 2
  }
};

export default localTomcatConfig;
